import { cx } from '@emotion/css';
import { StarRounded } from '@mui/icons-material';
import { TYPOGRAPHY } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { providersConfig } from '_features/Providers/config';

import { FakeOpportunity, getFakeOpportunities } from '../../utils';
import * as S from './styles';

type Props = {
  className?: string;
};

export function OpportunityIllustration(props: Props) {
  const { className } = { ...props };
  const { t } = useTranslation(providersConfig.i18nNamespaces);
  const opportunities: FakeOpportunity[] = getFakeOpportunities(t);

  return (
    <div className={cx(className, 'layout-column')}>
      {opportunities.map((opportunity: FakeOpportunity, index: number) => (
        <S.Opportunity
          className={cx(
            { 'shadow-2': index === 1 },
            { 'shadow-3': index === 2 },
            { 'border border-secondary-700': index === 1 },
            index === 0 ? 'bg-secondary-200' : 'bg-neutral-50',
            'layout-column  layout-align-start-start relative rounded-lg p-8',
          )}
          key={opportunity.id}>
          {index === 1 && (
            <div className="layout-row layout-align-center-center py-1 px-2 rounded-xs small text-success-700 bg-success-200 mb-4">
              <StarRounded style={{ fontSize: TYPOGRAPHY.P }} className="mr-1" />
              <span>{t('providers:modules.opportunity.fake.newOpportunity')}</span>
            </div>
          )}
          <span className="h4 bold mb-2">{opportunity.title}</span>
          <div className=" mb-1 rounded-md overflow-hidden width-100 bg-secondary-300 my-1" />
          <div className=" mb-4 width-50 rounded-md overflow-hidden bg-secondary-300 my-1" />
          <span className="rounded-sm bg-success-300 text-success-700 py-2 px-4 layout-row layout-align-center-center">
            {t('providers:modules.opportunity.fake.btnLabel')}
          </span>
        </S.Opportunity>
      ))}
    </div>
  );
}
